module.exports = __webpack_public_path__ + "img/FLOWTRONEX.1adea648.png";